import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color, Details, Summary, Typography } from '@figure/frontlib-gui';
import { numericFormatter } from '@figure/frontlib-util';
import Collapsed from 'shared/assets/images/dropdown-collapsed.svg';
import Expanded from 'shared/assets/images/dropdown-expanded.svg';

const Container = styled.div`
  margin: 30px 0;
`;

const TotalBar = styled.div`
  width: 100%;
  height: 7px;
  background-color: ${Color.LINE_GREY};
  position: relative;
  border-radius: 3.5px;
  overflow: hidden;
`;

const CurrentBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => `${props.width}%`};
  height: 100%;
  background-color: ${Color.TEAL};
`;

const H2 = styled(Typography.SmallBody)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 16px;

  img {
    vertical-align: middle;
    padding-left: 8px;
  }
`;

const NoIncomeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

const SummaryContainer = ({ name, value, isOpen }) => (
  <Summary outlineOffset="2px">
    <H2 as="h2">
      {name}
      <span>
        {value}
        <img src={isOpen ? Collapsed : Expanded} alt="" />
      </span>
    </H2>
  </Summary>
);

SummaryContainer.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
};

SummaryContainer.defaultProps = {
  isOpen: true,
};

const ProgressBar = ({ name, currentValue = 0, totalValue = 1, children, toggleEnabled }) => {
  const value =
    currentValue >= totalValue
      ? '100%'
      : `${numericFormatter.formatMoney(currentValue)} / ${numericFormatter.formatMoney(totalValue)}`;

  return (
    <Container>
      {toggleEnabled ? (
        <Details open summaryContent={<SummaryContainer name={name} value={value} />}>
          {children}
        </Details>
      ) : (
        <NoIncomeWrapper>
          <Typography.SmallBody as="h2">{name}</Typography.SmallBody>
          <Typography.SmallBody>{value}</Typography.SmallBody>
        </NoIncomeWrapper>
      )}
      <TotalBar>
        <CurrentBar width={(currentValue / totalValue) * 100} />
      </TotalBar>
    </Container>
  );
};

ProgressBar.propTypes = {
  name: PropTypes.string.isRequired,
  currentValue: PropTypes.number,
  totalValue: PropTypes.number,
  children: PropTypes.node,
  toggleEnabled: PropTypes.bool,
};

ProgressBar.defaultProps = {
  currentValue: undefined,
  totalValue: undefined,
  children: null,
  toggleEnabled: true,
};

export default ProgressBar;
